import { render } from "./ProductImage.vue?vue&type=template&id=3a1418f5&scoped=true"
import script from "./ProductImage.vue?vue&type=script&lang=js"
export * from "./ProductImage.vue?vue&type=script&lang=js"

import "./ProductImage.vue?vue&type=style&index=0&id=3a1418f5&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1418f5"]])

export default __exports__